module.exports = __webpack_public_path__ + "static/trig_010-dc72ff29063bf6e3c798cacf4bf0fc2c.webp";